import styled from 'styled-components'
import Button from 'builder/components/Button'

export const StyledButton = styled(Button)`
  width: fit-content;
`
